import React from "react";
import FaqWrapper from "./FaqWrapper";

function FaqPage() {
  return (
    <>
         <section className="section-bottom-pad"><FaqWrapper /></section>
    </>
  );
}

export default FaqPage;
